// extracted by mini-css-extract-plugin
export default {"fr-view":"Navigation_fr-view__cgQj9","container":"Navigation_container__NeXCm","menu-expanded":"Navigation_menu-expanded__oVKpP","back-button":"Navigation_back-button__B2UOa"};